require('./bootstrap');

import { createApp } from "vue";
import router from "./router";
import VueSweetalert2 from "vue-sweetalert2";
import 'sweetalert2/dist/sweetalert2.min.css';
import VueClipboard from 'vue-clipboard2'
import axios from 'axios';
import VueAxios from 'vue-axios'

//TERMOS 
import Termos from "./components/Termos.vue";

//HOME 
import PublicacaoEdital from "./components/home/PublicacaoEdital.vue";
import Agenda from "./components/home/agenda/Agenda.vue";
import AgendaCard from "./components/home/agenda/AgendaCard.vue";
import Contato from "./components/home/Contato.vue";
import ModalContato from "./components/home/ModalContato.vue";
import HomeBanners from "./components/home/Banners.vue";
import MosaicoCard from "./components/home/mosaico/MosaicoCard.vue";
import HomeMosaico from "./components/home/mosaico/Mosaico.vue";
import DetalhesLote from "./components/home/lote/DetalhesLote.vue";
import HomeListarLotes from "./components/home/lote/ListarLotes.vue";
import EnviarProposta from "./components/proposta/EnviarPropostaParcelamento.vue";
import EnviarPropostaCompra from "./components/proposta/EnviarPropostaCompra.vue";

//ADMIN 
import Apis from "./components/admin/apis/Listar.vue";
import ListarPropostas from "./components/admin/propostas/Listar.vue";
import SysControllMails from "./components/admin/sys_controll/Mails.vue";
import DarkMode from "./components/admin/DarkMode.vue";
import AdminEditarCadastro from "./components/admin/cadastros/EditarCadastro.vue";
import CadastrarDocTipoUsuario from "./components/admin/documentos_por_tipo_usuario/Cadastrar.vue";
import ListarDocTipoUsuario from "./components/admin/documentos_por_tipo_usuario/Listar.vue";
import UserDocuments from "./components/admin/UserDocuments.vue";
import UserDocumentView from "./components/admin/UserDocumentView.vue";
import FluxoCadastroAbas from "./components/admin/FluxoCadastroAbas.vue";

//NEWSLETTER EMAILS
import ListarNewsletterEmails from "./components/admin/newsletter_emails/Listar.vue";

//NEWSLETTER LISTAS
import ListarNewsletterListas from "./components/admin/newsletter_listas/Listar.vue";
import CriarNewsletterLista from "./components/admin/newsletter_listas/Cadastrar.vue";
import NewsletterExibirEmailsCadastrados from "./components/admin/newsletter_listas/ListarEmailsCadastrados.vue";
import NewsletterExibirEmailsNaoCadastrados from "./components/admin/newsletter_listas/ListarEmailsNaoCadastrados.vue";

//NEWSLETTER
import UnsubcribeNewsletter from "./components/UnsubcribeNewsletter.vue";
import EditarNewsletter from "./components/admin/newsletter/Editar.vue";
import ListarNewsletter from "./components/admin/newsletter/Listar.vue";
import CriarNewsletter from "./components/admin/newsletter/Cadastrar.vue";
import DetalhesNewsletter from "./components/admin/newsletter/Detalhes.vue";

//PUBLICACAO OFICIAL
import CadastrarPublicacao from "./components/admin/publicacao/Cadastrar.vue";
import EditalAnexo from "./components/home/EditalAnexo.vue";

//BLOCKNAMES
import ListarBlockNames from "./components/admin/blocknames/Listar.vue";
import CadastrarBlockName from "./components/admin/blocknames/Cadastrar.vue";
import EditarBlockName from "./components/admin/blocknames/Editar.vue";

//FOTOS
import ImportarEmMassa from "./components/admin/fotos/ImportarEmMassa.vue";
import ListarFotos from "./components/admin/fotos/Listar.vue";
import CadastrarFoto from "./components/admin/fotos/Cadastrar.vue";
import EditarFoto from "./components/admin/fotos/Editar.vue";

//CADASTROS
import CadastrosLogs from "./components/admin/cadastros/Logs.vue";
import CadastrosTodos from "./components/admin/cadastros/Todos.vue";
import DetalhesCadastro from "./components/admin/cadastros/Detalhes.vue";
import CadastrarHabilitacaoManual from "./components/admin/cadastros/CadastrarHabilitacaoManual.vue";

//WORKFLOW
import Workflow from "./components/admin/Workflow.vue";
import ConfirmandoEmail from "./components/admin//workflow/ConfirmandoEmail.vue";
import ConfirmandoTelefone from "./components/admin//workflow/ConfirmandoTelefone.vue";
import PreenchendoCadastro from "./components/admin//workflow/PreenchendoCadastro.vue";
import AguardandoLiberacao from "./components/admin//workflow/AguardandoLiberacao.vue";
import Pendentes from "./components/admin//workflow/Pendentes.vue";

//COMITENTES
import ListarComitentes from "./components/admin/comitentes/Listar.vue";
import CadastrarComitente from "./components/admin/comitentes/Cadastrar.vue";
import EditarComitente from "./components/admin/comitentes/Editar.vue";

//PROCESSOS
import ListarProcessos from "./components/admin/processos/Listar.vue";
import CadastrarProcesso from "./components/admin/processos/Cadastrar.vue";
import EditarProcesso from "./components/admin/processos/Editar.vue";

//LOGOS
import ListarLogos from "./components/admin/logos/Listar.vue";
import CadastrarLogo from "./components/admin/logos/Cadastrar.vue";
import EditarLogo from "./components/admin/logos/Editar.vue";

//LEILOES
import ListarLeiloes from "./components/admin/leiloes/Listar.vue";
import CadastrarLeilao from "./components/admin/leiloes/Cadastrar.vue";
import EditarLeilao from "./components/admin/leiloes/Editar.vue";
import LogsLeilao from "./components/admin/leiloes/Logs.vue";

//RELATÓRIOS
import LeiloesEmAberto from "./components/admin/relatorio/LeiloesEmAberto.vue";
import RelatorioArremates from "./components/admin/relatorio/Arremate.vue";
import RelatorioVendas from "./components/admin/relatorio/Venda.vue";

//LOTES
import GerarDocumento from "./components/admin/lotes/GerarDocumento.vue";
import ListarLotes from "./components/admin/lotes/Listar.vue";
import CadastrarLote from "./components/admin/lotes/Cadastrar.vue";
import EditarLote from "./components/admin/lotes/Editar.vue";
import LogsLotes from "./components/admin/lotes/Logs.vue";
import Importar from "./components/admin/lotes/Importar.vue";

//BANNERS
import ListarBanners from "./components/admin/banner/Listar.vue";
import CadastrarBanner from "./components/admin/banner/Cadastrar.vue";
import EditarBanner from "./components/admin/banner/Editar.vue";

//DOCUMENTOS
import AdminListarDocumentos from "./components/admin/documentos/Listar.vue";

//MAIL TEMPLATES
import ListarMailTemplates from "./components/admin/mail_templates/Listar.vue";

//TERMOS
import ListarTermos from "./components/admin/termos/Listar.vue";
import LogsTermos from "./components/admin/termos/Logs.vue";

//ADMIN HABILITACOES
import AdminHabilitacoes from "./components/admin/habilitacoes/Listar.vue";

//MODELOS DOCS
import ModelosDocs from "./components/admin/modelos_docs/Listar.vue";

//AUDITORIO ADMIN
import AuditorioAdminPropostas from "./components/admin/auditorio/Propostas.vue";
import AuditorioAdmin from "./components/admin/auditorio/Listar.vue";
import AuditorioCard from "./components/admin/auditorio/AuditorioCard.vue";

//TEXTO PADRÃO 
import EditarTextoPadrao from "./components/admin/texto_padrao/Editar.vue";
import CadastrarTextoPadrao from "./components/admin/texto_padrao/Cadastrar.vue";
import ListarTextosPadrao from "./components/admin/texto_padrao/Listar.vue";

//LANCES
import ListarLances from "./components/admin/lances/Listar.vue";
import ResetarLances from "./components/admin/lances/ResetarLances.vue";

//REGISTROS DELETADOS ADMIN
import RegistrosDeletados from "./components/admin/registros_deletados/Listar.vue";

//USUÁRIOS ADMIN
import UsuariosAdmin from "./components/admin/usuarios-admin/Listar.vue";
import EditarUsuarioAdmin from "./components/admin/usuarios-admin/Editar.vue";
import CriarUsuarioAdmin from "./components/admin/usuarios-admin/Criar.vue";


//USER 
import UserPropostas from "./components/user/Propostas.vue";
import ExibirTermos from "./components/home/Termos.vue";
import UserAuditorio from "./components/user/Auditorio.vue";
import UserHabilitacoes from "./components/user/Habilitacoes.vue";
import CompletarCadastroPF from "./components/user/CompletarCadastroPF.vue";
import CompletarCadastroPJ from "./components/user/CompletarCadastroPJ.vue";
import ListarDocumentos from "./components/user/ListarDocumentos.vue";
import SelecionarTipoCadastro from "./components/user/SelecionarTipoCadastro.vue";
import UserDashboard from "./components/user/Dashboard.vue";
import EditarCadastro from "./components/user/cadastro/EditarCadastro.vue";
import UserTermos from "./components/user/Termos.vue";
import UserArrematacoes from "./components/user/Arrematacoes.vue";

//HELPERS
import HelpApelido from "./components/HelpApelido.vue";

import VerificarSMS from "./components/VerificarSMS.vue";

import Proposta from "./components/proposta/Proposta.vue";

import PrimeVue from 'primevue/config';

//OPÇÃO 3
const vue = createApp({
    components: {}
})

import VueHtmlToPaper from "vue-html-to-paper";

// Vuetify
import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import AlterarSenha from "./components/user/cadastro/AlterarSenha.vue";

const vuetify = createVuetify({
    components,
    directives,
})

vue.use(VueHtmlToPaper)
vue.use(vuetify)
vue.use(PrimeVue)
vue.use(VueAxios, axios)
vue.use(VueClipboard)
vue.use(VueSweetalert2);
vue.use(router)

//ALTERAR SENHA
vue.component('alterar-senha', AlterarSenha)

//NEWSLETTER EMAILS
vue.component('admin-listar-newsletter-emails', ListarNewsletterEmails)

//NEWSLETTER LISTAS
vue.component('admin-listar-newsletter-listas', ListarNewsletterListas)
vue.component('admin-cadastrar-newsletter-emails', CriarNewsletterLista)
vue.component('admin-newsletter-emails-cadastrados', NewsletterExibirEmailsCadastrados)
vue.component('admin-newsletter-emails-nao-cadastrados', NewsletterExibirEmailsNaoCadastrados)

//NEWSLETTER
vue.component('unsubscribe-newsletter', UnsubcribeNewsletter)
vue.component('admin-editar-newsletter', EditarNewsletter)
vue.component('admin-cadastrar-newsletter', CriarNewsletter)
vue.component('admin-listar-newsletter', ListarNewsletter)
vue.component('admin-detalhes-newsletter', DetalhesNewsletter)

//TERMOS
vue.component('listar-apis', Apis)
vue.component('termos', Termos)

//HELPER
vue.component('help-apelido', HelpApelido)

//BLOCKNAMES
vue.component('admin-listar-blocknames', ListarBlockNames)
vue.component('cadastrar-blockname', CadastrarBlockName)
vue.component('editar-blockname', EditarBlockName)

//USUÁRIOS ADMIN
vue.component('admin-usuarios-admin', UsuariosAdmin)
vue.component('criar-usuario-admin', CriarUsuarioAdmin)
vue.component('editar-usuario-admin', EditarUsuarioAdmin)

//AUDITORIO ADMIN
vue.component('admin-cadastrar-texto-padrao', CadastrarTextoPadrao)
vue.component('admin-editar-texto-padrao', EditarTextoPadrao)
vue.component('admin-listar-textos-padrao', ListarTextosPadrao)
vue.component('admin-auditorio-propostas', AuditorioAdminPropostas)
vue.component('admin-auditorio', AuditorioAdmin)
vue.component('admin-auditorio-card', AuditorioCard)

//PROPOSTA
vue.component('proposta', Proposta)

//HOME PUBLICAÇÃO - EDITAL
vue.component('home-publicacao-edital', PublicacaoEdital)

//PUBLICAÇÃO OFICIAL
vue.component('cadastrar-publicacao', CadastrarPublicacao)
vue.component('home-edital-anexo', EditalAnexo)

//MODAL CONTATO
vue.component('home-agenda', Agenda)
vue.component('agenda-card', AgendaCard)
vue.component('contato', Contato)
vue.component('modal-contato', ModalContato)

//HABILITAÇÕES
vue.component('user-auditorio', UserAuditorio)
vue.component('user-habilitacoes', UserHabilitacoes)

//VERIFICAR SMS
vue.component('verificar-sms', VerificarSMS)

//VERIFICAR SMS
vue.component('dark-mode', DarkMode)

//HOME

//BANNERS
vue.component('home-banners', HomeBanners)

//MOSAICO
vue.component('home-mosaico', HomeMosaico)

//CARD MOSAICO
vue.component('card-mosaico', MosaicoCard)

//DETALHES LOTES
vue.component('detalhes-lote', DetalhesLote)
vue.component('enviar-proposta', EnviarProposta)
vue.component('enviar-proposta-compra', EnviarPropostaCompra)

//LISTAR LOTES
vue.component('home-listar-lotes', HomeListarLotes)

//ADMIN

//PROPOSTAS
vue.component('admin-modelos-docs', ModelosDocs)

//PROPOSTAS
vue.component('admin-listar-propostas', ListarPropostas)

//SYS CONTROLL
vue.component('admin-sys-controll-mail', SysControllMails)

//HABILITAÇÕES
vue.component('admin-habilitacoes', AdminHabilitacoes)

//FOTOS
vue.component('admin-importar-fotos-em-massa', ImportarEmMassa)
vue.component('admin-listar-fotos', ListarFotos)
vue.component('admin-cadastrar-foto', CadastrarFoto)
vue.component('admin-editar-foto', EditarFoto)

//MAIL TEMPLATE
vue.component('admin-listar-mail-templates', ListarMailTemplates)

//TERMOS
vue.component('admin-listar-termos', ListarTermos)
vue.component('admin-termos-logs', LogsTermos)

//FLUXO DE CADASTRO ABAS
vue.component('admin-editar-cadastro', AdminEditarCadastro)

//FLUXO DE CADASTRO ABAS
vue.component('admin-cadastrar-habilitacao-manual', CadastrarHabilitacaoManual)
vue.component('admin-detalhes-cadastro', DetalhesCadastro)
vue.component('admin-cadastros-todos', CadastrosTodos)
vue.component('admin-cadastros-logs', CadastrosLogs)

//FLUXO DE CADASTRO ABAS
vue.component('admin-fluxo-cadastro-abas', FluxoCadastroAbas)

//DOCUMENTOS
vue.component('admin-documentos', AdminListarDocumentos)

//BANNERS
vue.component('admin-listar-banners', ListarBanners)
vue.component('admin-cadastrar-banner', CadastrarBanner)
vue.component('admin-editar-banner', EditarBanner)

//LOTES
vue.component('admin-gerar-documentos', GerarDocumento)
vue.component('admin-importar-lotes', Importar)
vue.component('admin-listar-lotes', ListarLotes)
vue.component('admin-cadastrar-lote', CadastrarLote)
vue.component('admin-editar-lote', EditarLote)
vue.component('admin-lotes-logs', LogsLotes)

//RELATÓRIOS
vue.component('admin-leiloes-em-aberto', LeiloesEmAberto)
vue.component('admin-relatorio-arremate', RelatorioArremates)
vue.component('admin-relatorio-venda', RelatorioVendas)

//LEILOES
vue.component('admin-listar-leiloes', ListarLeiloes)
vue.component('admin-cadastrar-leilao', CadastrarLeilao)
vue.component('admin-editar-leilao', EditarLeilao)
vue.component('admin-leilao-logs', LogsLeilao)

//LOGOS
vue.component('admin-listar-logos', ListarLogos)
vue.component('admin-cadastrar-logo', CadastrarLogo)
vue.component('admin-editar-logo', EditarLogo)

//PROCESSOS
vue.component('admin-listar-processos', ListarProcessos)
vue.component('admin-cadastrar-processo', CadastrarProcesso)
vue.component('admin-editar-processo', EditarProcesso)

//COMITENTE
vue.component('admin-comitentes', ListarComitentes)
vue.component('admin-editar-comitente', EditarComitente)
vue.component('admin-cadastrar-comitente', CadastrarComitente)

//USER DOCUMENT VIEW
vue.component('admin-user-document-view', UserDocumentView)

//USER DOCUMENTS
vue.component('admin-user-documents', UserDocuments)

//WORKFLOW
vue.component('workflow', Workflow)

//WORKFLOW EMAIL NÃO CONFIRMADO
vue.component('workflow-unverified-mail', ConfirmandoEmail)

//WORKFLOW SMS NÃO CONFIRMADO
vue.component('workflow-unverified-phone', ConfirmandoTelefone)

//WORKFLOW PREENCHENDO CADASTRO
vue.component('workflow-non-profile', PreenchendoCadastro)

//WORKFLOW AGUARDANDO LIBERAÇÃO
vue.component('workflow-aguardando-liberacao', AguardandoLiberacao)

//PENDENTES
vue.component('workflow-pendentes', Pendentes)

//CADASTRAR DOCUMENTOS POR TIPO USUÁRIO
vue.component('cadastrar-doc-tipo-usuario', CadastrarDocTipoUsuario)

//LISTAR DOCUMENTOS POR TIPO USUÁRIO
vue.component('listar-doc-tipo-usuario', ListarDocTipoUsuario)

//LANCES
vue.component('admin-listar-lances', ListarLances)
vue.component('admin-resetar-lances', ResetarLances)
vue.component('admin-registros-deletados', RegistrosDeletados)


//USER

//USER DASHBOARD
vue.component('user-arrematacoes', UserArrematacoes)

//USER DASHBOARD
vue.component('user-termos', UserTermos)

//USER DASHBOARD
vue.component('editar-cadastro', EditarCadastro)

//USER DASHBOARD
vue.component('user-propostas', UserPropostas)

//EXIBIR TERMOS
vue.component('termos', ExibirTermos)

//USER DASHBOARD
vue.component('user-dashboard', UserDashboard)

//SELECIONAR TIPO CADASTRO
vue.component('selecionar-tipo-cadastro', SelecionarTipoCadastro)

//COMPLETAR CADASTRO PF
vue.component('completar-cadastro-pf', CompletarCadastroPF)

//COMPLETAR CADASTRO PJ
vue.component('completar-cadastro-pj', CompletarCadastroPJ)

//LISTAR DOCUMENTOS
vue.component('user-listar-documentos', ListarDocumentos)


vue.mount("#app")